import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CoreModule } from '@app/core';
import { AppSetting } from '@messaia/cdk';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxMaskModule } from 'ngx-mask';
import { NgxPrinterModule } from 'ngx-printer';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';

registerLocaleData(localeDe);

const appearance: MatFormFieldDefaultOptions = {
	appearance: 'outline'
};

@NgModule({
	declarations: [
		AppComponent,
		MainComponent
	],
	imports: [
		CoreModule,
		AppRoutingModule,
		ReactiveFormsModule,
		EditorModule,
		NgxMaskModule.forRoot(),
		NgxPrinterModule.forRoot({ timeToWaitRender: 0 }),
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
	],
	exports: [],
	providers: [
		{
			provide: AppSetting,
			useValue: <AppSetting>environment
		}, {
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: appearance
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }